import { Box, Center, Divider, Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { t } from "i18next";
import { AssigneeHeader } from "../../../../../../components/AssigneeHeader";
import React, { Fragment, useEffect, useState } from "react";
import PreviewConsumptionBased
  from "../../../../components/SuppliersDataReport/components/preview/PreviewConsumptionBased";
import { BlockHeader } from "../../../../../../components/BlockHeader";
import { General } from "../../../../../SupplierQuestionnaire/components/Revenue/components/General";
import { ScopeOne } from "../../../../../SupplierQuestionnaire/components/Revenue/components/ScopeOne";
import { ScopeTwo } from "../../../../../SupplierQuestionnaire/components/Revenue/components/ScopeTwo";
import { ScopeThree } from "../../../../../SupplierQuestionnaire/components/Revenue/components/ScopeThree";
import { SUPPLIER_QUESTIONNAIRE_TYPES } from "../../../../../../utils";

function RevenueModalBody({ data, isOpen }) {
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (!isOpen && tabIndex !== 0) {
      setTabIndex(0);
    }
  }, [isOpen, tabIndex]);

  return (<Flex direction="column">
    <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex}>
      <Center>
        <TabList borderBottom="none">
          <Tab
            _focus={{ boxShadow: "none" }}
            marginInline={data.questionnaireType === SUPPLIER_QUESTIONNAIRE_TYPES.CONSUMPTION_BASED ? 2 : null}
          >
            {data.questionnaireType === SUPPLIER_QUESTIONNAIRE_TYPES.CONSUMPTION_BASED ?
              t("reportsPage.suppliersData.modal.generalTab") :
              t("reportsPage.suppliersData.modal.generalAndScope1And2Tab")
            }
          </Tab>
          {data.questionnaireType === SUPPLIER_QUESTIONNAIRE_TYPES.CONSUMPTION_BASED &&
            <Tab _focus={{ boxShadow: "none" }} marginInline={2}>
              {t("reportsPage.suppliersData.modal.scope1And2Tab")}
            </Tab>
          }
          <Tab
            _focus={{ boxShadow: "none" }}
            marginInline={data.questionnaireType === SUPPLIER_QUESTIONNAIRE_TYPES.CONSUMPTION_BASED ? 2 : 4}
          >
            {t("reportsPage.suppliersData.modal.scope3Tab")}
          </Tab>
        </TabList>
      </Center>
      <AssigneeHeader
        assignee={{
          name: data.assigneeName,
          avatarUrl: ""
        }}
        period={data.period}
      />
      <TabPanels>
        <TabPanel padding="0" height={"var(--chakra-sizes-xl)"} overflow="auto">
          <Box paddingBottom="6">
            <BlockHeader
              title={t("supplierQuestionnaire.general.title")}
              description={t("supplierQuestionnaire.general.subtitle")}
            />
          </Box>
          <General
            defaultValues={data}
            isPreview={true}
          />
          {data.questionnaireType !== SUPPLIER_QUESTIONNAIRE_TYPES.CONSUMPTION_BASED &&
            <Fragment>
              <Divider marginBlock={5} />
              <Box paddingBlock={6}>
                <BlockHeader
                  title={t("supplierQuestionnaire.scopeOne.title")}
                  description={t("supplierQuestionnaire.scopeOne.subtitle")}
                />
              </Box>
              <ScopeOne
                defaultValues={data}
                isPreview={true}
              />
              <Divider marginBlock={5} />
              <Box paddingBlock={6}>
                <BlockHeader
                  title={t("supplierQuestionnaire.scopeTwo.title")}
                  description={t("supplierQuestionnaire.scopeTwo.subtitle")}
                />
              </Box>
              <ScopeTwo
                defaultValues={data}
                isPreview={true}
              />
            </Fragment>
          }
        </TabPanel>
        {data.questionnaireType === SUPPLIER_QUESTIONNAIRE_TYPES.CONSUMPTION_BASED ?
          <TabPanel padding="0">
            <Box paddingBottom="6">
              <PreviewConsumptionBased
                data={data.revenue?.consumptionBased?.preview ?? {}}
              />
            </Box>
          </TabPanel> : null
        }
        <TabPanel padding="0">
          <Box paddingBottom="6">
            <BlockHeader
              title={t("supplierQuestionnaire.scopeThree.title")}
              description={t("supplierQuestionnaire.scopeThree.subtitle")}
            />
            <ScopeThree
              id={data.id}
              categories={data.revenue?.categories ?? {}}
              consumptionBasedData={data.revenue?.consumptionBased ?? {}}
              questionnaireType={data.questionnaireType}
              isReviewModalUsed={true}
              isPreview={true}
            />
          </Box>
        </TabPanel>
      </TabPanels>
    </Tabs>
  </Flex>);
}

export default RevenueModalBody;